<template>
	<div id="content">
		<shutter-panel ref="shutterPanel" />
	</div>
</template>

<script type="text/javascript">
	import ShutterCongelation from "@/mixins/shutters-manager/Congelation.js"

	export default {
		name: 'Expedition',
		mixins: [ShutterCongelation],
		props: ['horse_id', 'status'],
		mounted() {
			this.setUpExpeditionList(this.horse_id, this.status)
		},
		watch: {
			status() {
				this.setUpExpeditionList(this.horse_id, this.status)
			}
		}
	}
</script>